export const validateFaculty = (
  data,
  step,
  category,
  subject,
  facId,
  useref_validation
) => {
  const errors = {};
  const phoneNumberRegex = /^\d{10}$/;
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  if (data.fname === "" && step === 0) {
    errors.fname = "Please enter first name";
  }
  if (data.lname === "" && step === 0) {
    errors.lname = "Please enter Last name";
  }
  if (data.phoneNumber === "" && step === 0) {
    errors.phoneNumber = "Please enter phone number";
  }
  if (
    !phoneNumberRegex.test(data.phoneNumber) &&
    data.phoneNumber !== "" &&
    step === 0
  ) {
    errors.phoneNumber = "Please enter a valid 10-digit phone number";
  }
  if (data.email === "" && step === 0) {
    errors.email = "Please enter email";
  }
  if (!emailRegex.test(data.email) && data.email !== "" && step === 0) {
    errors.email = "Please enter a valid email address";
  }
  // else if (!data.TeachType && step === 0) {
  //   errors.TeachType = "Please choose job type";
  // }
  if (data.designation === "" && step === 0) {
    errors.designation = "Please choose designation";
  }
  if (data.DJoin === "" && step === 0) {
    errors.DJoin = "Please enter Date of Join";
  }
  if (data.location === "" && step === 0) {
    errors.location = "Please enter location";
  }
  if ((facId === "1" || facId === 1) && data.is_eligible_class === "") {
    errors.jobType = "Please select job type";
  }
  // if (category.length === 0 && (facId === "0" || facId === 0)) {
  //   errors.category = "Please choose at least one category";
  // }
  // if (subject.optionSelected === null && (facId === "0" || facId === 0)) {
  //   errors.optionSelected = "Please select an option";
  // }

  // for (let i = 0; i < subject.length; i++) {
  //   const cert = subject[i].optionSelected;
  //   if (cert === null) {
  //     errors.optionSelected = "Please select subject for respective category ";
  //   }
  //   // Add additional validation rules for SSLC/HSC_Path if necessary
  // }
  validateFFFaculty(data, step, category, subject, facId, useref_validation);
  return errors;
};

export const validateFFFaculty = (
  data,
  step,
  category,
  subject,
  facId,
  useref_validation
) => {
  const errors = {};
  const phoneNumberRegex = /^\d{10}$/;
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  if (data.fname === "" && step === 0) {
    useref_validation.firstName.focus();
  } else if (data.lname === "" && step === 0) {
    useref_validation.lastName.focus();
  } else if (data.phoneNumber === "" && step === 0) {
    useref_validation.phoneNumber.focus();
  } else if (
    !phoneNumberRegex.test(data.phoneNumber) &&
    data.phoneNumber !== "" &&
    step === 0
  ) {
    useref_validation.phoneNumber.focus();
  } else if (data.email === "" && step === 0) {
    useref_validation.email.focus();
  } else if (!emailRegex.test(data.email) && data.email !== "" && step === 0) {
    useref_validation.email.focus();
  }
  // else if (!data.TeachType && step === 0) {
  // }
  else if (data.designation === "" && step === 0) {
    useref_validation.designation.focus();
  } else if (data.DJoin === "" && step === 0) {
    useref_validation.dateOfJoining.setFocus();
  } else if (data.location === "" && step === 0) {
    useref_validation.location.focus();
  }

  // else if (category.length === 0 && (facId === "0" || facId === 0)) {
  //   useref_validation.category.focus();
  // } else if (
  //   subject.optionSelected === null &&
  //   (facId === "0" || facId === 0)
  // ) {
  //   useref_validation.category.focus();
  // }

  // for (let i = 0; i < subject.length; i++) {
  //   const cert = subject[i].optionSelected;
  //   if (cert === null) {
  //     useref_validation.category.focus();
  //   }
  // }

  return errors;
};

export const validateForms = (data) => {
  const errors = {};
  if (!data.Adminstatus) {
    errors.Adminstatus = "Please Choose status";
  }
  if (!data.comments) {
    errors.comments = "Please enter comment";
  }

  return errors;
};

export const validatePanelMember = (data, useref_panelmembers, addJob) => {
  const errors = {};
  const jobErrors = [];
  const phoneNumberRegex = /^\d{10}$/;
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

  if (data.fname === "") {
    errors.fname = "Please enter first name";
  }
  if (data.lname === "") {
    errors.lname = "Please enter last name";
  }
  if (data.phoneNumber === "") {
    errors.phoneNumber = "Please enter phone number";
  }
  if (!phoneNumberRegex.test(data.phoneNumber) && data.phoneNumber !== "") {
    errors.phoneNumber = "Please enter a valid 10-digit phone number";
  }
  if (data.email === "") {
    errors.email = "Please enter email";
  }
  if (!emailRegex.test(data.email) && data.email !== "") {
    errors.email = "Please enter a valid email address";
  }
  if (data.status === "") {
    errors.status = "Please choose status";
  }
  if (data.is_eligible_class === "") {
    errors.jobType = "Please select job type";
  }
  addJob.forEach((job, index) => {
    const jobError = {};

    if (!job.department_id || job.department_id === "") {
      jobError.department = "Please choose department";
    }

    if (!job.designation_id || job.designation_id === "") {
      jobError.designation = "Please choose designation";
    }

    jobErrors.push(jobError);
  });

  validateFPanelMember(data, useref_panelmembers, addJob);
  return { ...errors, jobErrors };
};

export const validateFPanelMember = (data, useref_panelmembers, addJob) => {
  const errors = {};
  const phoneNumberRegex = /^\d{10}$/;
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

  if (data.fname === "") {
    errors.fname = "Please enter first name";
    useref_panelmembers.firstName.focus();
  } else if (data.lname === "") {
    errors.lname = "Please enter Last name";
    useref_panelmembers.lastName.focus();
  } else if (data.phoneNumber === "") {
    errors.phoneNumber = "Please enter phone number";
    useref_panelmembers.phoneNumber.focus();
  } else if (
    !phoneNumberRegex.test(data.phoneNumber) &&
    data.phoneNumber !== ""
  ) {
    errors.phoneNumber = "Please enter a valid 10-digit phone number";
    useref_panelmembers.phoneNumber.focus();
  } else if (data.email === "") {
    errors.email = "Please enter email";
    useref_panelmembers.email.focus();
  } else if (!emailRegex.test(data.email) && data.email !== "") {
    errors.email = "Please enter a valid email address";
    useref_panelmembers.email.focus();
  } else if (data.status === "") {
    errors.status = "Please choose status";
    useref_panelmembers.status.focus();
  } else {
    // ✅ Validate all entries in addJob
    for (let i = 0; i < addJob.length; i++) {
      const job = addJob[i];
      if (!job.department_id || job.department_id === "") {
        errors.department = `Please choose department for entry ${i + 1}`;
        break;
      } else if (!job.designation_id || job.designation_id === "") {
        errors.designation = `Please choose designation for entry ${i + 1}`;
        break;
      }
    }
  }

  return errors;
};

export const validateSalary = (data, staff_type) => {
  const errors = {};


  // Date: "",
  // MonthOf: "",
  // TSalary: staff_type === "0" ? "" : amount,
  // deduction: "",
  // THSalary: "",
  // eDate: "",
  // no_class: "",
  // salaryBased: "0",
  // sDate: "",
  // per_class_amount: "",

  if (data.Date === "") {
    errors.Date = "Please select Date";
  }
  if (data.description === "") {
    errors.description = "Please enter description";
  }
  if (data.per_class_amount === "" && data.salaryBased === "0") {
    errors.per_class_amount = "Please enter amount";
  }
  if (data.sDate === "" && data.salaryBased === "0") {
    errors.sDate = "Please select start date";
  }

  if (data.eDate === "" && data.salaryBased === "0") {
    errors.eDate = "Please select end date";
  }
  if (data.no_class === "" && data.salaryBased === "0") {
    errors.no_class = "Please enter no of class";
  }

  if (data.MonthOf === "" && data.salaryBased === "1") {
    errors.MonthOf = "Please select Month Of";
  } else if (data.TSalary === "" && data.salaryBased === "1") {
    errors.TSalary = "Please enter Total Salary";
  }

  if (data.deduction === "") {
    errors.deduction = "Please enter deduction";
  } else if (data.deduction > data.TSalary) {
    errors.deduction = "Deduction should not be greater than total salary";
  }
  // else if (data.THSalary === "") {
  //   errors.THSalary = "Please enter Take Home Salary";
  // }

  return errors;
};

// export const validateRaiseQuery =(e)=>{
//   const errors={};
//   if (queryText.queryTextarea === "") {
//     errors.queryTextarea = "Please enter text area";
//   }

//   if (!queryText.queryFile) {
//     errors.queryFile = "Please select a file";
//   }
// }
